/**
 * HTTP layer for vendor parts. The parts a vendor supplies and their pricing.
 *
 * Contains:
 * - fetchVendorParts / fetchVendorPart: reads
 * - postVendorPart / patchVendorPart / deleteVendorPart: writes
 */
import apiClient from '@sophocles/http-common';

const VENDOR_PARTS_ENDPOINT = '/warehouse/vendor-parts';

export const fetchVendorParts = queryParams =>
  apiClient.get(`${VENDOR_PARTS_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchVendorPart = vendorPartId =>
  apiClient.get(`${VENDOR_PARTS_ENDPOINT}/${vendorPartId}/`).then(res => res.data);

export const postVendorPart = data => apiClient.post(`${VENDOR_PARTS_ENDPOINT}/`, data).then(res => res.data);

export const patchVendorPart = (vendorPartId, data) =>
  apiClient.patch(`${VENDOR_PARTS_ENDPOINT}/${vendorPartId}/`, data).then(res => res.data);

export const deleteVendorPart = vendorPartId => apiClient.delete(`${VENDOR_PARTS_ENDPOINT}/${vendorPartId}/`);
